(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rovyfe-product')) {
  customElements.define('rovyfe-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const option = event.target.closest('[data-option-id]');
        if (option) this.selectOption(option);
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) this.showMedia(thumbnail.dataset.mediaTarget);
        const arrow = event.target.closest('[data-direction]');
        if (arrow) this.advanceMedia(Number(arrow.dataset.direction));
      });
      this.querySelector('.gallery').addEventListener('keydown', event => {
        if (event.target.closest('video, iframe, model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.advanceMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
    advanceMedia(direction) {
      const slides = [...this.querySelectorAll('.gallery-slide')];
      if (!slides.length) return;
      const index = slides.findIndex(slide => !slide.hidden);
      this.showMedia(slides[(index + direction + slides.length) % slides.length].dataset.mediaId);
    }
    showMedia(id) {
      const slides = [...this.querySelectorAll('.gallery-slide')];
      if (!slides.some(slide => slide.dataset.mediaId === id)) return;
      slides.forEach(slide => {
        slide.hidden = slide.dataset.mediaId !== id;
        if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-current', String(button.dataset.mediaTarget === id)));
    }
    async selectOption(button) {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      button.closest('fieldset').querySelectorAll('[data-option-id]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const selected = [...this.querySelectorAll('[data-option-id][aria-pressed="true"]')].map(item => item.dataset.optionId);
      const info = this.querySelector('.product-info');
      const quantity = info.querySelector('[name="quantity"]').value;
      const detailsOpen = info.querySelector('details').open;
      info.setAttribute('aria-busy', 'true');
      info.querySelector('[name="add"]').disabled = true;
      info.querySelector('[name="id"]').disabled = true;
      info.querySelector('.variant-error').hidden = true;
      const url = new URL(this.dataset.productUrl, location.origin);
      url.searchParams.set('option_values', selected.join(','));
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Variant request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('rovyfe-product .product-info');
        if (!updated) throw new Error('Missing variant content');
        if (controller.signal.aborted) return;
        updated.querySelectorAll('noscript').forEach(element => element.remove());
        const input = updated.querySelector('[name="quantity"]');
        input.value = quantity;
        if (!input.checkValidity()) input.value = input.min || '1';
        updated.querySelector('details').open = detailsOpen;
        info.replaceWith(updated);
        updated.querySelectorAll('[data-option-id]').forEach(item => { if (item.dataset.optionId === button.dataset.optionId) item.focus({preventScroll: true}); });
        const pageUrl = new URL(location.href);
        pageUrl.searchParams.delete('option_values');
        if (updated.dataset.variantId) pageUrl.searchParams.set('variant', updated.dataset.variantId);
        else { pageUrl.searchParams.delete('variant'); pageUrl.searchParams.set('option_values', selected.join(',')); }
        history.replaceState({}, '', pageUrl);
        if (updated.dataset.featuredMedia) this.showMedia(updated.dataset.featuredMedia);
      } catch (error) {
        if (error.name !== 'AbortError') {
          info.removeAttribute('aria-busy');
          info.querySelector('.variant-error').hidden = false;
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
